export default "__VITE_ASSET__CFzfMcyo__"